<template>
  <div id="conteneurDonnees">
    <Toast />
    <HeaderHome :user="this.$store.state.user.prenom" />

    <main class="page-main">
      <div class="page-header">
        <div class="page-header-left">
          <h1 class="page-title">Gestion</h1>
          <p class="page-subtitle">{{ agence.nom || 'Données de l\'agence' }}</p>
        </div>
        <button class="btn-save" @click="updateAgence">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
          Enregistrer
        </button>
      </div>

      <div class="page-card">
        <div class="form-body">

          <!-- Section : Informations générales -->
          <div class="section">
            <div class="field-row">
              <div class="field-group">
                <label class="field-label">Nom</label>
                <input type="text" class="field-input" placeholder="Nom de l'agence" v-model="agence.nom" @keydown="errors = ''" />
              </div>
              <div class="field-group">
                <label class="field-label">Adresse</label>
                <input type="text" class="field-input" placeholder="Adresse" v-model="agence.adresse" @keydown="errors = ''" />
              </div>
            </div>
            <div class="field-row">
              <div class="field-group">
                <label class="field-label">Code postal</label>
                <input type="text" class="field-input" placeholder="Code postal" v-model="agence.codePostal" @keydown="errors = ''" />
              </div>
              <div class="field-group">
                <label class="field-label">Ville</label>
                <input type="text" class="field-input" placeholder="Ville" v-model="agence.ville" @keydown="errors = ''" />
              </div>
            </div>
            <div class="field-row">
              <div class="field-group">
                <label class="field-label">Téléphone</label>
                <input type="text" class="field-input" placeholder="Numéro de téléphone" v-model="agence.telephone" @keydown="errors = ''" />
              </div>
              <div class="field-group">
                <label class="field-label">Siret</label>
                <input type="text" class="field-input" placeholder="Numéro Siret" v-model="agence.siret" @keydown="errors = ''" />
              </div>
            </div>
            <div class="field-row">
              <div class="field-group">
                <label class="field-label">Responsable</label>
                <input type="text" class="field-input" placeholder="Nom du responsable" v-model="agence.responsable" @keydown="errors = ''" />
              </div>
              <div class="field-group"></div>
            </div>
          </div>

          <!-- Section : Agréments -->
          <div class="section">
            <div class="field-row">
              <div class="field-group">
                <label class="field-label">Numéro d'agrément</label>
                <input type="text" class="field-input" placeholder="Numéro d'agrément" v-model="agence.numAgrement" @keydown="errors = ''" />
              </div>
              <div class="field-group">
                <label class="field-label">Numéro déclaration d'activité</label>
                <input type="text" class="field-input" placeholder="Numéro de déclaration" v-model="agence.numDeclarActivite" @keydown="errors = ''" />
              </div>
            </div>
          </div>

          <!-- Section : Assurance -->
          <div class="section">
            <div class="field-row">
              <div class="field-group">
                <label class="field-label">Numéro assurance</label>
                <input type="text" class="field-input" placeholder="Numéro assurance" v-model="agence.numAssurance" @keydown="errors = ''" />
              </div>
              <div class="field-group">
                <label class="field-label">Numéro police assurance</label>
                <input type="text" class="field-input" placeholder="Numéro police" v-model="agence.numPoliceAssurance" @keydown="errors = ''" />
              </div>
            </div>
            <div class="field-row">
              <div class="field-group">
                <label class="field-label">Nom police assurance</label>
                <input type="text" class="field-input" placeholder="Nom police assurance" v-model="agence.nomPoliceAssurance" @keydown="errors = ''" />
              </div>
              <div class="field-group"></div>
            </div>
          </div>

          <!-- Section : Fonds de garantie -->
          <div class="section">
            <div class="field-row">
              <div class="field-group">
                <label class="field-label">Numéro fond de garantie</label>
                <input type="text" class="field-input" placeholder="Numéro fond de garantie" v-model="agence.numFondGanrantie" @keydown="errors = ''" />
              </div>
              <div class="field-group">
                <label class="field-label">Montant fond de garantie</label>
                <input type="number" step="0.01" class="field-input" placeholder="0.00" v-model="agence.montantFondGarantie" @keydown="errors = ''" />
              </div>
            </div>
          </div>

          <!-- Section : Contact & Paramètres -->
          <div class="section">
            <div class="field-row">
              <div class="field-group">
                <label class="field-label">Droit heure conduite</label>
                <input type="number" class="field-input" placeholder="0" v-model="agence.droit" @keydown="errors = ''" />
              </div>
              <div class="field-group">
                <label class="field-label">Limite niveau examen</label>
                <input type="number" class="field-input" placeholder="0" v-model="agence.examProgress" @keydown="errors = ''" />
              </div>
            </div>
            <div class="field-row">
              <div class="field-group">
                <label class="field-label">Seuil H à programmer (AAC)</label>
                <input type="number" class="field-input" placeholder="ex : 20" v-model="agence.niveauAac" @keydown="errors = ''" />
              </div>
              <div class="field-group"></div>
            </div>
          </div>

        </div>
      </div>

      <button class="btn-mails" @click="openMailsDialog">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="5" width="18" height="14" rx="2"/>
          <path d="M3 7l9 6 9-6"/>
        </svg>
        Gestion des emails
      </button>
    </main>

    <Dialog
      v-model:visible="showMailsDialog"
      modal
      header="Gestion des emails"
      :style="{ width: '640px', maxWidth: '95vw' }"
    >
      <div class="mails-body">
        <div class="mails-row" v-for="m in mailsList" :key="m.key">
          <div class="mails-row-title">{{ m.label }}</div>
          <div class="field-row">
            <div class="field-group">
              <label class="field-label">Adresse mail</label>
              <input type="email" class="field-input" placeholder="email@agence.fr" v-model="mailsForm[m.key]" />
            </div>
            <div class="field-group">
              <label class="field-label">Nouveau mot de passe</label>
              <input type="password" class="field-input" placeholder="Laisser vide pour ne pas changer" v-model="mailsForm[m.key + 'Mdp']" autocomplete="new-password" />
            </div>
          </div>
        </div>
      </div>

      <div class="mails-actions">
        <button class="btn-save" @click="saveMails">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
          Enregistrer
        </button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { useToast } from "primevue/usetoast";
import HeaderHome from "@/components/home/HeaderHome.vue";

export default {
  components: { HeaderHome },

  data() {
    return {
      toast: useToast(),
      agence: {},
      errors: "",
      showMailsDialog: false,
      mailsList: [
        { key: "mailStage", label: "Stage de code" },
        { key: "mailPaiement", label: "Paiement" },
        { key: "mailhConduite", label: "Heures de conduite" },
        { key: "mailDossier", label: "Dossier" },
        { key: "mailContrat", label: "Contrat" },
        { key: "mailAgence", label: "Agence" },
      ],
      mailsForm: {
        mailStage: "",
        mailStageMdp: "",
        mailPaiement: "",
        mailPaiementMdp: "",
        mailhConduite: "",
        mailhConduiteMdp: "",
        mailDossier: "",
        mailDossierMdp: "",
        mailContrat: "",
        mailContratMdp: "",
        mailAgence: "",
        mailAgenceMdp: "",
      },
    };
  },

  mounted() {
    this.Champs();
  },

  methods: {
    async Champs() {
      try {
        window.api
          .get(`agences/${this.$store.state.user.agence.id}`, {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          })
          .then((result) => {
            this.agence = result.data;
          });
      } catch (e) {
        console.log(e);
      }
    },

    updateAgence() {
      window.api
        .put(`agences/${this.$store.state.user.agence.id}`, this.agence, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          this.toast.add({
            severity: "success",
            summary: "Enregistré",
            detail: "Les données de l'agence ont été mises à jour",
            life: 3000,
          });
          this.$emit("completed", response.data);
        })
        .catch((error) => {
          this.toast.add({
            severity: "error",
            summary: "Erreur",
            detail: "Une erreur est survenue lors de l'enregistrement",
            life: 3000,
          });
          console.log(error.response);
        });
    },

    openMailsDialog() {
      this.mailsList.forEach((m) => {
        this.mailsForm[m.key] = this.agence[m.key] || "";
        this.mailsForm[m.key + "Mdp"] = "";
      });
      this.showMailsDialog = true;
    },

    saveMails() {
      let payload = {};

      this.mailsList.forEach((m) => {
        if (this.mailsForm[m.key] !== "" && this.mailsForm[m.key] != null) {
          payload[m.key] = this.mailsForm[m.key];
        }
        let mdpKey = m.key + "Mdp";
        if (this.mailsForm[mdpKey] !== "" && this.mailsForm[mdpKey] != null) {
          payload[mdpKey] = this.mailsForm[mdpKey];
        }
      });

      window.api
        .put(`agence/${this.$store.state.user.agence.id}/mails`, payload, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then(() => {
          this.toast.add({
            severity: "success",
            summary: "Enregistré",
            detail: "Les emails ont été mis à jour",
            life: 3000,
          });
          this.showMailsDialog = false;
          this.mailsList.forEach((m) => {
            this.mailsForm[m.key + "Mdp"] = "";
          });
        })
        .catch((error) => {
          this.toast.add({
            severity: "error",
            summary: "Erreur",
            detail: "Une erreur est survenue lors de l'enregistrement",
            life: 3000,
          });
          console.log(error.response);
        });
    },
  },
};
</script>

<style scoped>
#conteneurDonnees {
  background: #f4f6f9;
  min-height: 100vh;
}

/* ===================== PAGE MAIN ===================== */
.page-main {
  width: 90%;
  margin: 0 auto;
  padding: 40px 40px;
  text-align: left;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
}

.page-header-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.page-title {
  font-size: 30px;
  font-weight: bold;
  color: #1a1f2e;
  letter-spacing: -0.5px;
  margin: 0;
}

.page-subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

/* ===================== BOUTON ===================== */
.btn-save {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 10px 20px;
  background: #3b82f6;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.18s;
}
.btn-save:hover { background: #2563eb; }

/* ===================== CARTE FORMULAIRE ===================== */
.page-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
}

.form-body {
  padding: 24px 28px;
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* ===================== SECTIONS ===================== */
.section {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-bottom: 24px;
  margin-bottom: 24px;
  border-bottom: 1px solid #f1f5f9;
}
.section:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

/* ===================== CHAMPS ===================== */
.field-row {
  display: flex;
  gap: 16px;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
}

.field-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}

.field-input {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  color: #1e293b;
  background: #f8fafc;
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.18s, background 0.18s;
}
.field-input:focus {
  border-color: #3b82f6;
  background: #ffffff;
}
.field-input::placeholder { color: #cbd5e1; }

/* ===================== BOUTON GESTION EMAILS ===================== */
.btn-mails {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 20px;
  padding: 10px 20px;
  background: #ffffff;
  color: #1a1f2e;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.18s;
}
.btn-mails:hover {
  border-color: #3b82f6;
  color: #3b82f6;
}

/* ===================== DIALOG GESTION EMAILS ===================== */
.mails-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.mails-row {
  padding-bottom: 20px;
  border-bottom: 1px solid #f1f5f9;
}
.mails-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.mails-row-title {
  font-size: 13px;
  font-weight: 700;
  color: #1a1f2e;
  margin-bottom: 10px;
}

.mails-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}
</style>
